module.exports = __webpack_public_path__ + "img/tensorflow.219ccb1f.png";